import ModelType from '@/lib/constants/challengeModel/ModelType.enum';
import { createContext } from 'react';
import { type ChallengeModels } from '../types';

// TODO this should be integrated properly and optimally to prevent unnecessary
// reloads, whilst accounting for coach-mode differences
const ModelsContext = createContext<ChallengeModels>({
  [ModelType.CHALLENGE]: [],
  [ModelType.TASK]: [],
});

export default ModelsContext;
